
window.addEventListener('DOMContentLoaded', (event) => {

  if (document.querySelectorAll('.fstars').length > 0 )
  {

    var reviewCount = 0;
    reviewCount = localStorage.getItem('reviews_' + productID);


    if (reviewCount != '' && !isNaN(reviewCount) && reviewCount > 0) {
    }
    else
    {
      reviewCount = randomInt(956, 4121);
      localStorage.setItem('reviews_' + productID, reviewCount);
    }
    document.querySelectorAll('.fstars .freview').forEach( (reviewBlock)=>  { 
      reviewBlock.innerText = reviewCount + ' reviews';  
    } ); 
  }
});